import { TITLE_UPDATE } from './actionTypes';

export const titleUpdate = title => {
  return {
    type: TITLE_UPDATE,
    title
  };
};
